export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  userBaseUrl: "/affbo",
  subAccessRoles: {
    account: "account",
    ticket: "ticket",
    bank: "bank",
    report: "report",
    log: "log",
    system: "system"
  },
  pageParent: {
    setting: "system",
    account: "account",
    dashboard: "system",
    member: "account",
    subaccount: "account",
    bank: 'bank',
    bankaffiliate: 'bank',
    ticket: 'ticket',
    withdrawal: 'ticket',
    settlementlist: "report",
    dailywinlose: "report",
    promomember: "report",
  },
  accessRoles: {
    account: "account",
    dashboard: "dashboard",
    member: "member",
    subaccount: "subaccount",
    bank: "bank",
    bankaffiliate: 'bankaffiliate',
    ticket: 'ticket',
    withdrawal: "withdrawal",
    report: "report",
    settlementlist: "settlementlist",
    dailywinlose: "dailywinlose",
    promomember: "promomember",
  },
  accessUrlPrefix: {
    member: "/account",
    subaccount: "/account",
    setting: "/system",
    bankaffiliate: "/bank",
    withdrawal: "/ticket",
    report: "/report",
    settlementlist: "/report",
    dailywinlose: "/report",
    promomember: "/report"
  },
  accessOptions: [
    'account', 'bank', 'ticket'
  ],
  loginUrl() {
    return this.baseUrl + this.userBaseUrl + "/login";
  },
  addSecondaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/addsecondary";
  },
  accountSubAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubadd";
  },
  accountSubDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubdetail";
  },
  accountSubListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsublist";
  },
  accountSubUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubupdate";
  },
  accountSubBlockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubblock";
  },
  accountSubUnblockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubunblock";
  },
  securityValidateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityvalidate";
  },
  securityUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityupdate";
  },
  securityDisableUrl() {
    return this.baseUrl + this.userBaseUrl + "/securitydisable";
  },
  memberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberlist";
  },
  bankAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankadd";
  },
  bankListUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklist";
  },
  bankLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklookup";
  },
  accountSubResetUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubreset";
  },
  passwordUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordupdate";
  },
  balanceGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/balanceget";
  },
  ticketWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketwithdrawal";
  },
  accountSignupUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsignup";
  },
  ticketListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlist";
  },
  tacRenewUrl() {
    return this.baseUrl + this.userBaseUrl + "/tacrenew";
  },
  tacValidateUrl() {
    return this.baseUrl + this.userBaseUrl + "/tacvalidate";
  },
  summaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/summary";
  },
  settlementListUrl() {
    return this.baseUrl + this.userBaseUrl + "/settlementlist";
  },
  dailyWinLoseUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlose";
  },
  dailyWinLoseMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlosemember";
  },
  affiliateUrlListUrl() {
    return this.baseUrl + this.userBaseUrl + "/affiliateurllist";
  },
  promoMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promomemberlist";
  },
};
